import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=7f3d5016&scoped=true&"
import script from "./DownloadIcon.vue?vue&type=script&lang=js&"
export * from "./DownloadIcon.vue?vue&type=script&lang=js&"
import style0 from "./DownloadIcon.vue?vue&type=style&index=0&id=7f3d5016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3d5016",
  null
  
)

export default component.exports